<template>
  <div
    v-if="showType == 'folding'"
    class="quality-box quality-box-material-folding"
  >
    <!-- <span class="normal-item current-choose">鲜木耳</span> -->
    <template v-for="(material, key) in list" :key="key">
      <span
        @click="chooseItem(material)"
        class="normal-item"
        :class="{ 'current-choose': material.isChoose }"
        >{{ material.skuName }}</span
      >
    </template>
    <span class="option-frag" @click="showType = 'spread'"></span>
  </div>
  <div
    v-if="showType == 'spread'"
    class="quality-box quality-box-material-spread"
  >
    <div class="material-spread-top">
      <span class="material-spread-title">全部原料</span>
      <span class="material-spread-close" @click="showType = 'folding'">✕</span>
    </div>
    <div class="material-spread-bottom">
      <template v-for="(material, key) in list" :key="key">
        <span
          @click="chooseItem(material)"
          class="normal-item"
          :class="{ 'current-choose': material.isChoose }"
          >{{ material.skuName }}</span
        >
      </template>
    </div>
  </div>
  <div class="quality-box quality-box-material-info">
    <template :key="index" v-for="(item, index) in lineInfo">
      <div v-if="item.detailVOS[0]?.fieldType == 3">
        <TraceLine :baseInfo="item"></TraceLine>
      </div>
      <div v-if="item.detailVOS[0]?.fieldType == 2">
        <TracePic :baseInfo="item"></TracePic>
      </div>
      <div v-if="item.detailVOS[0]?.fieldType == 1">
        <BaseInfo :baseInfo="item"></BaseInfo>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import BaseInfo from "./BaseInfo.vue";
import TraceLine from "./TraceLine.vue";
import TracePic from "./TracePic.vue";

export default defineComponent({
  name: "MaterialInfo",
  data() {
    return {
      showType: "folding",
      list: this.materialInfoList,
      lineInfo: {}
    };
  },

  props: {
    materialInfoList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mounted() {
    this.list.forEach(item => {
      item.isChoose = false;
    });
    this.list[0].isChoose = true;
    this.lineInfo = this.list[0].templateInfoList;
  },
  components: {
    TraceLine,
    TracePic,
    BaseInfo
  },

  methods: {
    chooseItem(menuItem) {
      this.list.forEach(item => {
        item.isChoose = false;
      });
      menuItem.isChoose = true;
      this.lineInfo = menuItem.templateInfoList;
    }
  }
});
</script>

<style lang="less" scoped>
.quality-box {
  background: white;
  margin-bottom: 0px !important;
  padding: 15px !important;
}
.quality-box-material-folding {
  margin-top: 8px;
  margin-bottom: 10px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: unset;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // -webkit-line-clamp: 1;
  line-height: 40px;
  height: 40px;
  padding: 0px 0px 0px 10px !important;
  position: relative;
  width: 100%;
  .option-frag {
    position: absolute;
    top: 0px;
    z-index: 00000000;
    background: white;
    right: 5px;
    box-shadow: -5px 0px 7px -4px #d1cbcb;
    padding: 0px 4px;
    background: url("../../../assets/icon-open-menu.png");
    background-repeat: no-repeat;
    background-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    width: 24px;
  }
}
.current-choose {
  background-color: #edf9f0;
  border-radius: 14px;
  background-size: 6px;
  line-height: 30px;
  font-size: 13px;
  color: #64c365 !important;
}
.normal-item {
  display: inline-block;
  padding: 0 10px;
  font-size: 13px;
  color: #999;
  line-height: 26px;
}
.quality-box-material-spread {
  margin-top: 8px;
  margin-bottom: 10px !important;
  padding: 0px 0px 0px 10px !important;
  .material-spread-top {
    border-bottom: 1px solid #eee;
    line-height: 36px;
    height: 36px;
    color: #4c4c4c !important;
    .material-spread-title {
      margin-left: 10px;
      font-size: 14px;
    }
    .material-spread-close {
      float: right;
      margin-right: 4px;
      font-size: 18px;
    }
  }
  .material-spread-bottom span {
    margin: 6px 0;
  }
}
</style>
